import React, { Component, Suspense } from 'react';
import PropTypes from 'prop-types';

import { withRouter, matchPath } from 'react-router-dom';
import Breadcrumbs from '../Helpers/Breadcrumbs';
import Shortcuts from '../UI/Shortcut';
import routes from '../../routes/routes';
import { withTranslation } from 'react-i18next';
import { getDepartmentLogo } from '../../api/department';
import { store } from '../../utils/store';
import { actionConstants } from '../../actions/actionConstants';

const PageTitle = (props) => {
  const deptId = JSON.parse(localStorage.getItem('userProfile')).departmentId;
  const { department } = store.getState();
  const logo = localStorage.getItem('logo');
  React.useEffect(() => {
    if (department.isLogoUpdated) {
      getDepartmentLogo(deptId)
        .then((resp) => {
          localStorage.setItem('logo', resp);
          store.dispatch({
            type: actionConstants.LOGO_HAS_UPDATED,
            data: false,
          });
        })
        .catch((err) => console.log(err));
    }
  }, []);
  function findTitle() {
    for (let route of routes) {
      if (matchPath(props.location.pathname, route)) {
        return props.t(route.title);
      }
    }
    return null;
  }
  function displayLogo() {
    if (logo) {
      return (
        <img
          src={logo}
          alt="department-logo"
          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        />
      );
    }
  }

  const settings = JSON.parse(localStorage.getItem('departmentSettings'));
  return (
    <Suspense fallback="loading">
      <div className="page-title d-flex justify-content-between align-items-center">
        <div className="d-flex flex-1 flex-column" style={{ maxWidth: 400 }}>
          <Breadcrumbs />
          <h1>{props.title || findTitle()}</h1>
        </div>
        <div className="d-flex flex-1 justify-content-center">
          <h1>
            {settings &&
              settings.filter(
                (setting) => setting.parameter === 'SystemName',
              )[0].value}
          </h1>
        </div>
        <div
          className="w-100 h-100"
          style={{ maxWidth: 200, maxHeight: 75, marginRight: 10 }}
        >
          {displayLogo()}
        </div>
        <Shortcuts />
      </div>
    </Suspense>
  );
};

PageTitle.propTypes = {
  location: PropTypes.object.isRequired,
};

PageTitle.defaultProps = {
  title: '',
};

export default withRouter(withTranslation('app')(PageTitle));
